import classNames from 'classnames'
import React from 'react'
import { useTranslations } from '../hooks/useTranslations'
import '../styles/factBox.css'
import { IS_EQT_FOUNDATION } from '../utilities/site'
import { isNullOrWhiteSpace, sanitizeHtmlAndReplaceNewlines } from '../utilities/string'
import { Box } from './Box'
import { Link } from './Link'

export interface FactBoxItem {
  heading?: string | null
  link?: string
  linkText?: string
  text?: string
}

export type Variant = 'plain' | 'numbers' | 'letters'

export interface FactBoxProps {
  body?: JSX.Element
  heading?: string
  variant?: Variant
  items?: Array<FactBoxItem>
}

export const factBoxParagraphClassName = 'mb-30 font-body text-body last:mb-0'

export const FactBox: React.FC<FactBoxProps> = ({
  body,
  heading,
  items,
  variant = 'plain',
}) => {
  const translations = useTranslations()
  let itemHeadingClassName: string | undefined
  let liClassName = factBoxParagraphClassName
  let olClassName: string | undefined

  if (variant === 'numbers') {
    itemHeadingClassName = 'float-left pr-5'
    liClassName = classNames(liClassName, 'pl-60 sm:pl-75')
    olClassName = 'fact-box__list-decimal'
  }

  return (
    <Box as="aside" variant="border">
      <div
        className={IS_EQT_FOUNDATION ? 'text-secondary-darker' : 'text-secondary-dark'}
      >
        {!isNullOrWhiteSpace(heading) && (
          <h2 className="font-h3 text-h3 mb-30 last:mb-0">{heading}</h2>
        )}

        {!body && (
          <ol className={olClassName}>
            {items?.map((item, index) => (
              <li className={liClassName} key={index}>
                {!isNullOrWhiteSpace(item.heading) && (
                  <h3 className={classNames('font-medium', itemHeadingClassName)}>
                    {item.heading}
                  </h3>
                )}

                <p className="font-light">
                  {!isNullOrWhiteSpace(item.text) && (
                    <span
                      dangerouslySetInnerHTML={{
                        __html: sanitizeHtmlAndReplaceNewlines(item.text),
                      }}
                    ></span>
                  )}

                  {!isNullOrWhiteSpace(item.link) && (
                    // Add one space before the 'More' text
                    <>
                      {' '}
                      <Link
                        className="font-t border-b border-quinary transition-hover hover:opacity-hover hover:border-opacity-50 hover:border-secondary-darker"
                        url={item.link}
                      >
                        {!isNullOrWhiteSpace(item.linkText)
                          ? item.linkText
                          : translations.more}
                      </Link>
                    </>
                  )}
                </p>
              </li>
            ))}
          </ol>
        )}

        {body}
      </div>
    </Box>
  )
}
